import React, { Component } from "react";
import { Link } from "react-router-dom";



class bookScrollList extends Component {
	constructor(props) {
		super(props)
		//this.state = { bl: [] };

		//alert(JSON.stringify(props));
                       let book_url="";

                    if( window.location.pathname.toLowerCase().indexOf("audiobook")>0 || 
                       window.location.search.toLowerCase().indexOf("audiobook")>0) {
                         book_url = "/audiobook";
                    } else {
                        book_url = "/book";
                        if( props.fetchurl.indexOf("suggesttype=21")>0 ) {
                            book_url = "/bookfree";
                        }
                    };


        this.state = { totalcount: 0, booklist: [], loading: true, struri: props.fetchurl, book_url:book_url};
        fetch(this.state.struri,
            {
                headers: {
                    'Cache-Control': 'no-cache'
                }
            })
            .then(response => response.json())
            .then(data => {
                this.setState({ totalcount: data.totalcount, booklist: data.lstresult, loading: false });
            });
    }

	dorender() {
		let bookDummy = this.state.booklist;
		if (bookDummy === undefined || bookDummy === null) return "";

		return (
			bookDummy.map((book, index) => {

				

				let strBookID = book.refbookid;
				if (strBookID === undefined ||  strBookID === null || strBookID.length === 0) {
					strBookID = book.id;
				}

				return (
					<React.Fragment>
						<li className="bookScrollList-item">
							<Link to={`${this.state.book_url}/${book.id}`}>
								<div className="bookScrollList-thumbnail">
									<div className="thumbnail">
										<img
											className="thumbnail-image"
											src={`/api/AB/GetCoverImage?thumb=2&imgid=${book.id}`}
											alt={book.subject}
										/>
									</div>
								</div>
								<h3 className="bookScrollList-title">{book.subject}</h3>
								<h4 className="bookScrollList-author">{book.authorName}</h4>
							</Link>
						</li>
					</React.Fragment>
				);
			})
		);
	}

	render() {
		let contents = this.state.loading === true
			? "Loading..."
			: this.dorender();

		return (
			<div className="bookScrollList-container">
				<ul className="bookScrollList">
					{contents}
				</ul>
			</div>
		);
	}
}

export default bookScrollList;
